import React from "react";
import styled from "styled-components";
import * as FaIcons from "react-icons/fa";

const ServicesSection = styled.div`
  text-align: center;
   background: linear-gradient(to right, #d28710 0%, #f39c12 100%);
  color: #fff;
  padding: 50px 0;
  @media (max-width: 480px) {
    width: 100%; 
  }
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.div`
  margin-bottom: 30px;

  h2 {
    color: #fff;
  }

  p {
    color: rgba(255, 255, 255, 0.75);
  }
`;

const IconGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;
const IconCard = styled.div`
  flex: 1 1 calc(25% - 20px);
  max-width: calc(25% - 20px);
  text-align: center;

  @media (max-width: 768px) {
    flex: 1 1 calc(50% - 20px);
  }

  @media (max-width: 480px) {
    flex: 1 1 100%;
  }

  svg {
    font-size: 50px;
    color: #ffffff;
    margin-bottom: 15px;
  }

  h3 {
    font-size: 2rem; 
    margin: 10px 0;

    @media (max-width: 768px) {
      font-size: 1.6rem; 
    }

    @media (max-width: 480px) {
      font-size: 1.5rem; 
    }
  }

  p {
    font-size: 1.5rem; 
    color: rgba(255, 255, 255, 0.75);

    @media (max-width: 768px) {
      font-size: 1.4rem; 
    }

    @media (max-width: 480px) {
      font-size: 1.3rem; 
    }
  }
`;


export const Services = (props) => {
  return (
    <ServicesSection id="services">
      <Container>
        <SectionTitle>
          <h2>Plots Sizes</h2>
          <p>
            Explore diverse plot sizes with modern designs, excellent connectivity, and ample space, perfect for building your dream home while enjoying a harmonious blend of comfort and convenience.
          </p>
        </SectionTitle>
        <IconGrid>
          {props.data
            ? props.data.map((d, i) => (
                <IconCard key={`${d.name}-${i}`}>
                  {d.icon &&
                    React.createElement(FaIcons[d.icon], {
                      size: 50,
                      color: "#ffffff",
                    })}
                  <h3>{d.name}</h3>
                  <p>{d.text}</p>
                </IconCard>
              ))
            : "loading"}
        </IconGrid>
      </Container>
    </ServicesSection>
  );
};
